import { Navigate } from "react-router-dom";

export type Role = "admin" | "user" | "restaurantAdmin";

interface Props {
  children: React.ReactNode;
  allowedRoles: Role[];
  userRole: Role | undefined;
}

export const ProtectedRoute = ({ children, allowedRoles, userRole }: Props) => {
  if (!userRole) {
    return <Navigate to="/dashboard/ login" />;
  }
  if (!allowedRoles.includes(userRole)) return <Navigate to="/unauthorized" />;

  return <>{children}</>;
};
